import React from "react";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { CustomerPortalCompanyInfo } from "../../../common/models";
interface Props {
  company: CustomerPortalCompanyInfo;
}

const ContactInfoBlock: React.FC<Props> = ({ company }): React.ReactElement => {
  const { tCompany, t } = useCustomTranslation();

  return (
    <div className="mt-4">
      <div className="mb-2.5 text-[14px]/[16px] font-bold uppercase">
        {tCompany("billing")}
      </div>
      <h3>{company.name}</h3>
      <div className="text-[16px]/[28px] tracking-[-0.16px]">
        <div>{company.street}</div>
        <div>{company.city}</div>
        <div>{company.postalCode}</div>
      </div>
      <div className="mt-1 text-[16px]/[28px] tracking-[-0.16px]">
        <div>
          {t("identification_number_value", {
            value: company.identificationNumber,
          })}
        </div>
        {company.taxNumber && (
          <div>{t("tax_number_value", { value: company.taxNumber })}</div>
        )}
      </div>
    </div>
  );
};

export default ContactInfoBlock;
